import DriveThruInfoV2 from './DriveThruInfoV2';

export default DriveThruInfoV2;
